import React from 'react'
import Typography from '@material-ui/core/Typography'

export const dataGridMovilConfig = [
	{
		title: 'Spare Part',
		dataSource: 'Code',
		sortable: false,
		onRenderProperty: (item) => {
			// The grid calls the renderer with no item while it is loading or resetting its rows.
			// Guarding here rather than inside the condition below, because that branch reads
			// `item.Code` on the way out and would throw a line later.
			if (!item) {
				return ''
			}
			// The mobile grid has a single column, so the discontinued warning rides inside this
			// cell instead of adding a second one that would blow past a phone's width.
			if (!item.IsDiscontinued || !item.Substitute) {
				return `${item.Code} | ${item.Description}`
			}
			return (
				<div>
					<Typography variant='body2' component='div'>
						{`${item.Code} | ${item.Description}`}
					</Typography>
					<Typography variant='caption' component='div' style={{ color: 'darkorange', fontWeight: 'bold' }}>
						{'DISCONTINUED'}
					</Typography>
					<Typography variant='caption' component='div'>
						{`Replaced by: ${item.Substitute.Code} | ${item.Substitute.Description}`}
					</Typography>
				</div>
			)
		}
	}
]
export default dataGridMovilConfig
